/**
 * contextProvider.js
 * -----------------------------------------------------------
 * Adaptateur permettant à l'application hôte (ITERCATUS demain,
 * la démo aujourd'hui) de transmettre à Blue un contexte de page
 * SANS que le module ne dépende de la structure interne de l'hôte.
 *
 * L'application hôte a deux options :
 *  1. Passer une prop `pageContext` au composant <BlueAssistant/>.
 *  2. Fournir une fonction `getPageContext()` qui sera appelée à
 *     chaque envoi de message (utile si le contexte évolue).
 *
 * Forme attendue du contexte (tout est optionnel) :
 *  {
 *    pageType: "article" | "destination" | "home" | string,
 *    title:    string,
 *    destination: string,
 *    userStatus:  "guest" | "member" | "partner" | string,
 *    locale:      "fr" | "en" | string,
 *    extra:       { ... }   // libre
 *  }
 * -----------------------------------------------------------
 */

export function resolvePageContext(pageContext, getPageContext) {
  if (typeof getPageContext === "function") {
    try {
      return normalizeContext(getPageContext());
    } catch (e) {
      // Un contexte invalide ne doit jamais casser le chat.
      // eslint-disable-next-line no-console
      console.warn("[BlueChat] getPageContext() a échoué :", e);
    }
  }
  return normalizeContext(pageContext);
}

function normalizeContext(ctx) {
  if (!ctx || typeof ctx !== "object") return {};
  const out = {};
  if (ctx.pageType) out.pageType = String(ctx.pageType);
  if (ctx.title) out.title = String(ctx.title);
  if (ctx.destination) out.destination = String(ctx.destination);
  if (ctx.userStatus) out.userStatus = String(ctx.userStatus);
  if (ctx.locale) out.locale = String(ctx.locale);
  if (ctx.extra && typeof ctx.extra === "object") out.extra = ctx.extra;
  return out;
}
